import {
  Info as Icon
} from 'components/icons';

export const meta = {
  id: 'Demos',
  title: 'demos',
  category: 'Demo',
  // exposes: [
  //   {
  //     title: 'demo',
  //     action: { module: 'Demos', props: { /* */ } },
  //   },
  //   {
  //     title: 'New demo',
  //     action: { module: 'DemosDetails', props: { context: 'add' } },
  //   },
  // ],
  unique: true,
  icon: Icon,
  version: '1.0.0',
  description: `Just a demo. Feel free to delete it if you are familiarized with the structure `,
  windowOptions: {
    // if not passed, will be centered
    // x: null,
    // y: null,
    // width: 630,
    // height: 380
  }
};
